import { ISettingsFormValues } from '../../containers/Form/Settings/SettingsForm'
import mapValuesToRequestSettings, {
  IRequestBody,
} from './mappers/mapValuesToRequestSettings'
import handleResponse from './request/handleSettingsResponse'

export default function(api: GlobalFetch) {
  return async function(data: ISettingsFormValues, id: number) {
    const requestBody: IRequestBody = mapValuesToRequestSettings(data, id)
    const response = await api.fetch(`/api/v2/object/index/`, {
      body: JSON.stringify(requestBody),
      method: 'PUT',
    })

    return await handleResponse(response)
  }
}
